
const config = {}
//TODO Find a better way. I could not find a way to pass values in config
if (window.location.port == '8080') {
  config.main_v1_path = `${window.location.protocol}//${window.location.hostname}:3000`
  config.main_v2_path = `${window.location.protocol}//${window.location.hostname}:8080`
} else if (window.location.port === '3000') {
  config.main_v1_path = window.location.origin;
  config.main_v2_path = window.location.origin;
} else if (window.location.hostname.includes("nexgate")) {
  config.main_v1_path = `${window.location.protocol}//${window.location.hostname}`
  config.main_v2_path = `${window.location.protocol}//${window.location.hostname}`
} else {
  config.main_v1_path = `${window.location.protocol}//v1.${window.location.hostname}`
  config.main_v2_path = `${window.location.protocol}//${window.location.hostname}`
}

config.is_main_same_server = config.main_v1_path === config.main_v2_path;

/*
Logout at main via js.
To avoid including this file in data_nav there will be a redirect from /logout to  [main_v1_path]/v2/logout
*/
//TODO use endpoints signOut instead; the following is currently used only on a POC page

config.logout_main = `${config.main_v1_path}/users/sign_out`

export default config